import { type SessionsData, sessionsDataSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'src/useAuth';

import { queryKeys } from './queryKeys';

export function useSessions() {
  const { authenticated, token } = useAuth();

  const {
    data: sessionsData,
    error,
    isLoading,
    refetch,
  } = useQuery<SessionsData>({
    queryKey: queryKeys.getSessions,
    queryFn: () => get({ url: '/user/account/sessions', schema: sessionsDataSchema }),
    enabled: authenticated || !!token,
  });

  return {
    sessions: sessionsData?.sessions ?? [],
    error,
    isLoading,
    refetch,
  };
}
